import cx from 'classnames'
import { m, type MotionValue } from 'motion/react'
import styles from './ScrollShadow.module.css'

interface ShadowProps {
  opacity: number | MotionValue<number>
  borderless?: boolean
  lift?: boolean
  placement?: 'top' | 'bottom'
}

/**
 * A shadow that shows content scrolled under an edge.
 */
export function ScrollShadow({
  opacity,
  borderless,
  lift,
  placement = 'bottom',
}: ShadowProps) {
  return (
    <m.div
      style={{ opacity }}
      className={cx(
        styles.root,
        borderless && styles.borderless,
        lift && styles.lift,
        placement === 'top' && styles.topPlacement,
      )}
    />
  )
}
